import { isWindows, isWinPhone } from 'react-device-detect';

const isWindowsOS = () => {
  return isWindows || isWinPhone;
};

export {
  isWindowsOS
};